import { SEND_CONTACT_FORM_MUTATION } from './useSendContactForm.graphql';
import {
  IHandleSendContactFormParams,
  ISendContactFormMutationGraphQLResponse,
  ISendContactFormMutationVariables,
  IUseSendContactFormOptions,
  IUseSendContactForm,
} from './useSendContactForm.interfaces';

import { useKanziMutation } from '../../apollo';

const useSendContactForm = (options?: IUseSendContactFormOptions): IUseSendContactForm => {
  const { mutation, onCompleted, onError, token } = options ?? ({} as IUseSendContactFormOptions);

  const [executeSendContactForm, { loading: isLoading }] = useKanziMutation<
    ISendContactFormMutationGraphQLResponse,
    ISendContactFormMutationVariables
  >({
    mutation: mutation ?? SEND_CONTACT_FORM_MUTATION,
    options: {
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          user: { sendContactForm: isCompleted },
        } = data;

        onCompleted({
          isCompleted,
        });
      },
      onError,
    },
    token,
  });

  const handleSendContactForm = async ({
    email,
    firstName,
    lastName,
    organisationName,
    phoneNumber,
    templateId,
    value,
  }: IHandleSendContactFormParams) => {
    await executeSendContactForm({
      variables: {
        email,
        firstName,
        lastName,
        organisationName,
        phoneNumber,
        templateId,
        value,
      },
    });
  };

  return {
    handleSendContactForm,
    isLoading,
  };
};

export { useSendContactForm };
